export default "__VITE_ASSET__DixwLBGc__"